import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@draeger-academy/common';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DaLinkModule } from '../da-link';
import { ResponsiveModule } from '@viablelogic/ngx-responsive';
import { SiteNavigationModule } from '../site-navigation/site-navigation.module';
import { HeaderComponent } from './header.component';
import { LanguageCountrySwitcherModule } from '../language-country-switcher';
import { CartModule } from '../cart';
import { LoginModule } from '../login';
import { MyAccountModule } from '../my-account/my-account.module';
import { AutoCompleteSearchV3Module } from '../auto-complete-search/auto-complete-search-v3.module';
import { AcsInputModule } from '../acs-input';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [HeaderComponent],
    imports: [
        CommonModule,
        RouterModule,
        SiteNavigationModule,
        ResponsiveModule,
        DaLinkModule,
        LanguageCountrySwitcherModule,
        PipesModule,
        LoginModule,
        MyAccountModule,
        CartModule,
        AutoCompleteSearchV3Module,
        AcsInputModule,
        LocalizeRouterModule.forChild([]),
        TranslateModule.forChild()
        
    ],
    exports: [HeaderComponent],
    providers: []
})
export class HeaderModule {}
